<div class="grid grid-cols-12 gap-6">
  <div id="company-info-tour" class="col-span-8" *appHasAnyPrivilege="'SETTING.COMPANY.INFORMATION.UPDATE'">
    <h6  class="mb-3">{{ 'settings.branding.companyInformation.title' | transloco }}</h6>
    <nz-alert
      class="mt-2 mb-5"
      nzType="warning"
      [nzMessage]="'settings.branding.companyInformation.warning' | transloco"></nz-alert>
    <div class="grid grid-cols-12 my-4">
      <div class="col-span-4">
        <div class="flex flex-col gap-4" *ngIf="uploadAndPreview">
          <div class="bg-base-200 h-56 p-8">
            <img
              class="w-full h-full object-contain"
              [src]="
                companyForm.get('logo').value
                  ? companyForm.get('logo').value
                  : placeholderPath
              "
              alt=""/>
          </div>
          <div class="flex justify-center items-center">
            <button nz-button nzType="default" (click)="uploadAndPreview = false">
              {{ 'settings.branding.companyInformation.changeLogo' | transloco }}
            </button>
          </div>
        </div>
        <div *ngIf="!uploadAndPreview">
          <ngx-dropzone [multiple]="false" (change)="onSelect($event)">
            <ngx-dropzone-label>{{ 'settings.branding.companyInformation.companyLogo' | transloco }}</ngx-dropzone-label>
            <ngx-dropzone-preview
              *ngFor="let f of files"
              [removable]="true"
              (removed)="onRemove(f)">
              <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>
          <nz-alert class="mt-2" nzType="info" nzShowIcon
                    [nzMessage]="'settings.branding.companyInformation.recommendedImage' | transloco"></nz-alert>
        </div>
      </div>
      <form nz-form [formGroup]="companyForm" class="col-span-8">
        <nz-form-item class="flex">
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-5/12 xl:w-5/12"
            nzRequired
            nzFor="companyName"
          >{{ 'settings.branding.companyInformation.fields.companyName' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="nameCheck">
            <input
              type="text"
              nz-input
              formControlName="companyName"
              [placeholder]="'settings.branding.companyInformation.placeholders.companyName' | transloco"/>
          </nz-form-control>
          <ng-template #nameCheck>
            <span *ngIf="formErrors.companyName.required">
              {{ 'settings.branding.companyInformation.errors.companyNameRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="flex">
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-5/12 xl:w-5/12"
            nzRequired
            nzFor="country"
          >{{ 'settings.branding.companyInformation.fields.country' | transloco }}
          </nz-form-label
          >
          <nz-form-control [nzErrorTip]="countryCheck">
            <nz-select
              formControlName="country"
              [nzPlaceHolder]="'settings.branding.companyInformation.placeholders.country' | transloco"
              nzShowSearch>
              <nz-option
                *ngFor="let data of orderByName(countries)"
                [nzValue]="data.code"
                [nzLabel]="data.emoji + ' ' + data.name"></nz-option>
            </nz-select>
          </nz-form-control>
          <ng-template #countryCheck>
            <span *ngIf="formErrors.country.required">
              {{ 'settings.branding.companyInformation.errors.countryRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="flex">
          <nz-form-label
            class="w-1/4 sm:w-1/5 lg:w-5/12 xl:w-5/12"
            nzFor="address"
          >{{ 'settings.branding.companyInformation.fields.address' | transloco }}
          </nz-form-label
          >
          <nz-form-control [nzErrorTip]="addressCheck">
            <textarea
              class=""
              [nzAutosize]="{ minRows: 3, maxRows: 3 }"
              formControlName="address"
              [placeholder]="'settings.branding.companyInformation.placeholders.address' | transloco"
              rows="5"
              maxlength="250"
              nz-input></textarea>
          </nz-form-control>
          <ng-template #addressCheck>
            <span *ngIf="formErrors.address.required">{{ 'settings.branding.companyInformation.errors.addressRequired' | transloco }}</span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="flex">
          <nz-form-label class="w-1/4 sm:w-1/5 lg:w-5/12 xl:w-5/12" nzRequired nzFor="summary"
          >{{ 'settings.branding.companyInformation.fields.companyDescription' | transloco }}
          </nz-form-label
          >
          <nz-form-control [nzErrorTip]="summaryCheck">
                <textarea
                  formControlName="summary"
                  [placeholder]="'settings.branding.companyInformation.placeholders.summary' | transloco"
                  rows="8"
                  [nzAutosize]="{ minRows: 3, maxRows: 3 }"
                  nz-input></textarea>
          </nz-form-control>
          <ng-template #summaryCheck>
            <span *ngIf="formErrors.summary.required">{{ 'settings.branding.companyInformation.errors.summaryRequired' | transloco }}</span>
          </ng-template>
        </nz-form-item>

        <nz-form-item class="flex">
          <nz-form-label class="w-1/4 sm:w-1/5 lg:w-5/12 xl:w-5/12" nzRequired nzFor="websiteLink"
          >{{ 'settings.branding.companyInformation.fields.websiteLink' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="websiteLinkCheck">
            <input
              type="text"
              nz-input
              formControlName="websiteLink"
              [placeholder]="'settings.branding.companyInformation.placeholders.websiteLink' | transloco"/>
          </nz-form-control>
          <ng-template #websiteLinkCheck>
            <span *ngIf="formErrors.websiteLink.required">{{ 'settings.branding.companyInformation.errors.websiteLinkRequired' | transloco }}</span>
            <span *ngIf="formErrors.websiteLink.pattern">{{ 'settings.branding.companyInformation.errors.websiteLinkInvalid' | transloco }}</span>
          </ng-template>
        </nz-form-item>

        <div class="flex justify-end">
          <button
            nz-button
            nzType="primary"
            [disabled]="companyForm.invalid"
            (click)="createOrUpdateBrand('company information')">
            {{ 'settings.common.update' | transloco }}
          </button>
        </div>
      </form>
    </div>
    <div *ngIf="msg === 'company information'">
      <nz-alert
        *ngIf="actionMessage.display && actionMessage.isAdd"
        class="mt-2"
        [nzType]="actionMessage.type"
        [nzMessage]="actionMessage.message"
        nzShowIcon
        nzCloseable></nz-alert>
    </div>
  </div>
  <div class="col-span-6">
    <ng-container *appHasAnyPrivilege="'SETTING.THEME.COLOR'">
    <div class="flex items-center gap-3">
      <h6>{{ 'settings.branding.themeSettings.title' | transloco }}</h6>
      <p>{{ 'settings.branding.themeSettings.description' | transloco }}</p>
    </div>
    <nz-alert
      class="mt-2 mb-5"
      nzType="warning"
      [nzMessage]="'settings.branding.themeSettings.warning' | transloco"></nz-alert>

    <div class="grid grid-cols-12 gap-3 mb-5">

      <div class="col-span-5 space-y-2">
        <p class="mt-3">{{ 'settings.branding.themeSettings.theme1' | transloco }}</p>
        <div class="flex flex-row gap-5 items-center ">
          <div class="rounded-full border border-white h-12 w-12"
              [ngStyle]="{'background-color': this.brandColorTheme1}"></div>
          <div>
            <input
              type="text"
              nz-input
              [placeholder]="'settings.branding.themeSettings.placeholders.color' | transloco"
              [(ngModel)]="this.brandColorTheme1"/>
            <div *ngIf="brandColorTheme1 && !isValidHexColor(this.brandColorTheme1)" style="color: red; font-size: 12px;">
              {{ 'settings.branding.themeSettings.errors.invalidHexColor' | transloco }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-span-5 space-y-2">
        <p class="mt-3">{{ 'settings.branding.themeSettings.theme2' | transloco }}</p>
        <div class="flex flex-row gap-5 items-center">
          <div class="rounded-full border border-white h-12 w-12"
              [ngStyle]="{'background-color': this.brandColorTheme2}"></div>
          <div>
            <input
              type="text"
              nz-input
              [placeholder]="'settings.branding.themeSettings.placeholders.color' | transloco"
              [(ngModel)]="this.brandColorTheme2"/>
            <div *ngIf="brandColorTheme1 && !isValidHexColor(this.brandColorTheme2)" style="color: red; font-size: 12px;">
              {{ 'settings.branding.themeSettings.errors.invalidHexColor' | transloco }}
            </div>
          </div>
        </div>
      </div>

      <div class=" col-span-2 flex items-end">
        <button
          nz-button
          class="mb-1"
          nzType="primary"
          [disabled]="!isValidHexColor(brandColorTheme1) || !isValidHexColor(brandColorTheme2)"
          (click)="updateBrandUIOptions('brand') ">
          {{ 'settings.common.update' | transloco }}
        </button>
      </div>
    </div>
    <div *ngIf="msg === 'brand'">
      <nz-alert
        *ngIf="actionMessage.display && actionMessage.isAdd"
        class="my-2"
        [nzType]="actionMessage.type"
        [nzMessage]="actionMessage.message"
        nzShowIcon
        nzCloseable></nz-alert>
    </div>
    </ng-container>
</div>
